import { SidebarItem } from '../screens';
import { useBreadcrumbs, useUser } from '../hooks';
import UserAccess from '../UserAccess';

interface OperacionesSidebarProps{

}

var OperacionesSidebar = (props: OperacionesSidebarProps)=>{
	var { showSearch } = useBreadcrumbs();
	var { hasAccess } = useUser();

	return <>
		<SidebarItem text='Buscar' iconName='search' onClick={showSearch} />
		<div className='divider'>General</div>
		{hasAccess(UserAccess.EVENTS.VIEW_EVENTS) && (
			<SidebarItem text='Dashboard' iconName='calendar-alt' to='/' />
		)}
		<SidebarItem text='Mis Eventos' iconName='calendar-check' to='/my-events' />
		{hasAccess(UserAccess.ISSUES.VIEW_ISSUES) && (
			<SidebarItem text='Tareas' iconName='tasks' to='/issues' />
		)}
		{hasAccess([UserAccess.ACCOUNTING.VIEW_EXPENSES, UserAccess.EVENTS.VIEW_BUDGET, UserAccess.ACCOUNTING.PAID_PAYOUT]) && (
			<div className='divider'>Contabilidad</div>
		)}
		{hasAccess(UserAccess.ACCOUNTING.VIEW_EXPENSES) && (
			<SidebarItem text='Gastos' iconName='money-bill-wave' to='/expenses' />
		)}
		{hasAccess(UserAccess.EVENTS.VIEW_BUDGET) && (
			<SidebarItem text='Presupuestos' iconName='file-invoice-dollar' to='/budgets' />
		)}
		{hasAccess(UserAccess.ACCOUNTING.PAID_PAYOUT) && (
			<SidebarItem text='Nómina' iconName='money-check-alt' to='/payouts' />
		)}
		{hasAccess([UserAccess.INVENTORY.VIEW_WAREHOUSES, UserAccess.INVENTORY.VIEW_INVENTORY_SHIPMENTS, UserAccess.INVENTORY.VIEW_INVENTORY, UserAccess.INVENTORY.VIEW_INVENTORY_REQUESTS]) && (
			<div className='divider'>Inventario</div>
		)}
		{hasAccess(UserAccess.INVENTORY.VIEW_WAREHOUSES) && (
			<>
				<SidebarItem text='Almacenes' iconName='warehouse' to='/warehouses' />
				<SidebarItem text='Mapa de almacenes' iconName='map-location' to='/map-warehouses' />
			</>
		)}
		{hasAccess(UserAccess.INVENTORY.VIEW_INVENTORY_SHIPMENTS) && (
			<SidebarItem text='Envíos' iconName='truck-fast' to='/shipments' />
		)}
		{hasAccess(UserAccess.INVENTORY.VIEW_INVENTORY) && (
			<SidebarItem iconName='layer-group' text='Equipos' to='/items' />
		)}
		{hasAccess(UserAccess.INVENTORY.VIEW_INVENTORY_REQUESTS) && (
			<SidebarItem iconName='laptop-file' text='Solicitudes' to='/requests' />
		)}
		{hasAccess(UserAccess.INVENTORY.VIEW_INVENTORY) && (
			<SidebarItem iconName='boxes' text='Tipos de inventario' to='/types' />
		)}
		{hasAccess([UserAccess.EVENTS.VIEW_PROMOTERS, UserAccess.FORMS.VIEW_FORMS, UserAccess.USERS.VIEW_USERS, UserAccess.WORKERS.VIEW_WORKERS, UserAccess.WORKERS.VIEW_WORKERS_TITLES, UserAccess.CONTRACTS.VIEW_CONTRACTS, UserAccess.EMPLOYMENTS.CREATE_PAYOUT]) && (
			<div className='divider'>Configuración</div>
		)}
		{hasAccess(UserAccess.EVENTS.VIEW_PROMOTERS) && (
			<SidebarItem text='Promotores' iconName='bullhorn' to='/promoters' />
		)}
		{hasAccess(UserAccess.FORMS.VIEW_FORMS) && (
			<SidebarItem text='Formularios' iconName='file' to='/forms' />
		)}
		{hasAccess(UserAccess.USERS.VIEW_USERS) && (
			<SidebarItem text='Usuarios' iconName='users' to='/users' />
		)}
		{hasAccess(UserAccess.WORKERS.VIEW_WORKERS) && (
			<SidebarItem text='Trabajadores' iconName='user-group' to='/workers' />
		)}
		{hasAccess(UserAccess.WORKERS.VIEW_WORKERS_TITLES) && (
			<SidebarItem text='Puestos' iconName='user-tag' to='/titles' />
		)}
		{hasAccess(UserAccess.CONTRACTS.VIEW_CONTRACTS) && (
			<SidebarItem text='Contratos' iconName='file-contract' to='/contract' />
		)}
		{hasAccess(UserAccess.EMPLOYMENTS.CREATE_PAYOUT) && (
			<SidebarItem text='Tipos de ajustes' iconName='tags' to='/adjustment-types' />
		)}
		{hasAccess(UserAccess.EMPLOYMENTS.VIEW_EMPLOYMENTS) && (
			<div className="divider">Check-in</div>
		)}
		{hasAccess(UserAccess.EMPLOYMENTS.VIEW_EMPLOYMENTS) && (
			<SidebarItem text='Dashboard' iconName='chart-line' to='/employees' exact />
		)}
		{hasAccess(UserAccess.EMPLOYMENTS.VIEW_EMPLOYMENTS) && (
			<SidebarItem text='Empleos' iconName='briefcase' to='/employments' />
		)}
		{hasAccess(UserAccess.EMPLOYMENTS.VIEW_EMPLOYMENTS) && (
			<SidebarItem text='Empleados' iconName='users' to='/employees/users' />
		)}
		{hasAccess(UserAccess.EMPLOYMENTS.VIEW_PAYMENTS) && (
			<SidebarItem text='Pagos' iconName='money-check-alt' to='/employees/payments' />
		)}
		{hasAccess(UserAccess.EMPLOYMENTS.VIEW_PAYOUTS) && (
			<SidebarItem text='Nómina' iconName='file-invoice-dollar' to='/employees/payouts' />
		)}
		{hasAccess([UserAccess.REPORTS.VIEW_TICKETS_REPORT, UserAccess.REPORTS.VIEW_REPORTS, UserAccess.REPORTS.VIEW_EVENTS_REPORT]) && (
			<div className="divider">Reportes</div>
		)}
		{hasAccess(UserAccess.REPORTS.VIEW_TICKETS_REPORT) && (
			<SidebarItem text='Aforo' iconName='ticket' to='/report/tickets' />
		)}		
		{hasAccess(UserAccess.REPORTS.VIEW_REPORTS) && (
			<SidebarItem text='Gastos' iconName='money-bill' to='/report/expense' />
		)}
		{hasAccess(UserAccess.REPORTS.VIEW_EVENTS_REPORT) && (
			<SidebarItem text='Eventos' iconName='calendar' to='/report/events' />
		)}
	</>
}

export default OperacionesSidebar;
